import http from '@/utils/http' 
import {getSign, getToken, getEstateId} from '@/utils/auth';
export function fetchList(query) {
  query.sign = getSign(query, getToken());
  return http({
    url: '/api/sys/user/index',
    method: 'get',
    params: query
  })
} 

export function manageestateids(id, query) {
  query.sign = getSign(query, getToken());
  return http({
    url: '/api/sys/user/admin/' + id,
    method: 'get',
    params: query
  })
} 

export function create(data) {
  const params = data
  return http.post('/api/sys/user?sign=' + getSign(params, getToken()), JSON.stringify(params));
}

export function edit(id, data) { 
  const params = data
  return http.put('/api/sys/user/' + id + '?sign=' + getSign(params, getToken()), JSON.stringify(params));
}

export function del(id) {
  const params = {'id': id}
  return http.delete('/api/sys/user/' + id + '?sign=' + getSign(params, getToken()), {data: JSON.stringify(params)}); 
}

export function resetPassword(id, data) { 
  const params = {
    'id': data.id,
    'loginpwd': data.loginpwd
  }
  return http.put('/api/sys/user/' + id + '/resetpwd?sign=' + getSign(params, getToken()), JSON.stringify(params));
}
 
export function changePwd(data) {
  return http.put('/api/sys/user/changepwd?sign=' + getSign(data, getToken()), JSON.stringify(data));
}
 
export function setRole(managerid, roleids) { 
  const params = {
    managerid: managerid,
    roleids: roleids
  }
  return http.put('/api/sys/user/roles?sign=' + getSign(params, getToken()), JSON.stringify(params)); 
}

export function setEstateRoom(data) { 
  const params = data
  return http.put('/api/sys/user/room?sign=' + getSign(params, getToken()), JSON.stringify(params));
}

export function setStatus(data) {
  const params = {
    id: data.id,
    status: data.status
  }
  return http.put('/api/sys/user/status?sign=' + getSign(params, getToken()), JSON.stringify(params));
}
 
export function updateRight(id, menuids) {
  let menus = [];
  menuids.forEach((menuid, index) => {
    menus.push({'id': menuid, 'selecttype': 1})
  })
  const params = {
    id: id,
    menuids: menus
  }
  return http.put('/api/sys/user/edit/menu?sign=' + getSign(params, getToken()), JSON.stringify(params));
}

export function getRole(eid, query) { 
  query.sign = getSign(query, getToken());
  return http({
    url: '/api/sys/user/roles/' + (undefined !== eid ? eid : ''),
    method: 'get',
    params: query
  }) 
}

export function getParent() { 
  const params = {where: {}, page: '[0,999999999]'}
  params.sign = getSign(params, getToken());
  return http({
    url: '/api/sys/user/child-company',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/base/sysuser.js